import type { SystemRole } from "@/lib/system-roles";

export type OnboardingStatus = "skipped" | "completed" | null;

export function toOnboardingStatus(
  onboardingStatus: string | null | undefined
): OnboardingStatus {
  return onboardingStatus === "skipped" || onboardingStatus === "completed"
    ? onboardingStatus
    : null;
}

export function canAccessOnboardingInDevelopment({
  pathname,
  isDevelopment,
  systemRole,
}: {
  pathname: string;
  isDevelopment: boolean;
  systemRole: SystemRole | null;
}) {
  return (
    isDevelopment && pathname === "/onboarding" && systemRole === "site_manager"
  );
}

export function getOnboardingRedirectPath({
  pathname,
  onboardingStatus,
  systemRole,
  allowDevelopmentAccess = false,
}: {
  pathname: string;
  onboardingStatus: OnboardingStatus;
  systemRole: SystemRole | null;
  allowDevelopmentAccess?: boolean;
}) {
  if (allowDevelopmentAccess && pathname === "/onboarding") {
    return null;
  }

  if (systemRole !== "site_manager") {
    return pathname === "/onboarding" ? "/dashboard" : null;
  }

  if (onboardingStatus === null) {
    return pathname === "/onboarding" ? null : "/onboarding";
  }

  return pathname === "/onboarding" ? "/dashboard" : null;
}
